import { Col, Row, Grid } from 'components/Grid'
import { Button } from 'components/Buttons'
import { COLORS } from 'constants/colors'
import I18n from 'locales'
import { downloadDocs } from 'services/audit'
import { stringToArrayBuffer } from 'utils/stringToArrayBuffer'
import CurrencyFormat from 'react-currency-format'
import { FadeLoader as Loader } from 'react-spinners'
import React, { Fragment } from 'react'
import classNames from 'classnames'
import './index.css'

const today = new Date()

const handleDocDownloadClick = (path, filename) => {
  downloadDocs(path)
    .then(({ request }) => {
      request.onloadend = event => {
        if (request.status === 200 && request.response !== 'File not founded') {
          let link = document.createElement('a')
          document.body.appendChild(link)
          link.download = `${filename}.pdf`
          const blob = new Blob([stringToArrayBuffer(atob(request.response))], {
            type: 'application/pdf',
          })
          link.href = window.URL.createObjectURL(blob)
          link.click()
        } else {
          window.M.toast({
            classes: 'Toast--failure',
            html: I18n.t('common.fail'),
          })
        }
      }
    })
    .catch(err => {
      console.error(err)
      let classes = 'Toast--failure'
      let html = I18n.t('common.fail')
      window.M.toast({
        classes,
        html,
      })
    })
}

const renderRealty = (
  {
    content: {
      Id,
      AdDate,
      Address,
      Bedrooms,
      Building,
      Category,
      Cep,
      City,
      Garages,
      Link,
      MeterPrice,
      Neighborhood,
      Price,
      RealState,
      TotalArea,
      UsefulArea,
      UsefulMeterPrice,
    },
    businessType,
  },
  openReportModal,
) => {
  let tempAdDate = new Date(AdDate)
  tempAdDate.setDate(tempAdDate.getDate() + 1)

  const adDate = Math.round((today - tempAdDate) / 86400000) + ' dia(s)'
  const rowClasses = classNames('InfoWindow__Row')
  const capitalizedClasses = classNames('InfoWindow--capitalized')
  const overFlowHiddenCapitalizedClasses = classNames(
    'InfoWindow--overflowhidden',
    'InfoWindow--capitalized',
  )
  const titleClasses = classNames('InfoWindow__Body__Content__Title')
  const contentClasses = classNames('InfoWindow__Body__Content')
  const timestamp = new Date()
    .toDateString()
    .split(' ')
    .join('-')

  return (
    <Grid fluid className={contentClasses}>
      <Row between="xs" center="xs" className={titleClasses}>
        <Col xs={12} md={11} className={capitalizedClasses}>
          <h2>
            {Category} - {businessType}
          </h2>
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col xs={12} className={capitalizedClasses}>
          <b>Endereço: </b> {Address && `${Address} - `}
          {Neighborhood && `${Neighborhood}, `}
          {City && `${City}`}
          {Cep && `, ${Cep}`}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col xs={12} md={6} className={capitalizedClasses}>
          <b>Edificio: </b> {Building || '-'}
        </Col>
        <Col xs={12} md={5}>
          <b>Valor (R$): </b>
          <CurrencyFormat
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            value={Price}
            displayType="text"
          />
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col xs={12} md={6}>
          <b>Dormitórios: </b> {Bedrooms}
        </Col>
        <Col xs={12} md={5}>
          <b>Área Total (m²): </b>
          {TotalArea}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Garagens: </b>
          {Garages}
        </Col>
        <Col md={5} xs={12}>
          <b>Área Útil (m²): </b>
          {UsefulArea}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12} className={overFlowHiddenCapitalizedClasses}>
          <b>Imobiliária: </b> {(RealState && RealState.toLowerCase()) || '-'}
        </Col>
        <Col md={5} xs={12}>
          <b>Valor/m² Total (R$): </b>
          {MeterPrice ? (
            <CurrencyFormat
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              value={MeterPrice}
              displayType="text"
            />
          ) : (
            '-'
          )}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Anúncio/Inclusão: </b> {adDate}
        </Col>
        <Col md={5} xs={12}>
          <b>Valor/m² Útil (R$): </b>
          {UsefulMeterPrice ? (
            <CurrencyFormat
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale
              value={UsefulMeterPrice}
              displayType="text"
            />
          ) : (
            '-'
          )}
        </Col>
      </Row>
      <Row between="xs" center="xs" style={{ marginTop: 10 }}>
        <Col md={6} xs={12}>
          <Button
            type="submit"
            btnSize="sm"
            btnStyle="link"
            className="InfoWindow__Body__Content__Btn"
            onClick={() =>
              window.open(
                Link.includes('zapimoveis') ? `${Link}?${timestamp}` : Link,
                '_tab',
              )
            }
          >
            <i className="material-icons">visibility</i>
            Ver Anúncio
          </Button>
        </Col>
        <Col md={6} xs={12}>
          <Button
            btnSize="sm"
            btnStyle="link"
            className="InfoWindow__Body__Content__Btn"
            onClick={() => window.open(`/rgi/${Id}/${businessType}`, '_tab')}
          >
            <i className="material-icons">assessment</i>
            Relatório
          </Button>
        </Col>
      </Row>
    </Grid>
  )
}

const renderValuated = ({
  content: {
    Id: id,
    IsAudit,
    Closed,
    ClosureDate,
    ClosureValue,
    Suite,
    AuctionDate,
    IsOccupied,
    DocumentsList,
    FirstAuctionValue,
    FirstAuctionDate,
    SecondAuctionValue,
    SecondAuctionDate,
    NegativeGoodwill,
    AdDate,
    Address,
    Bedrooms,
    Category,
    CategoryId,
    Cep,
    City,
    CityId,
    Uf,
    Garages,
    Link,
    MeterPrice,
    RatedValue,
    Neighborhood,
    NeighborhoodId,
    Price,
    TotalArea,
    UsefulArea,
    UsefulMeterPrice,
    Mapped,
    location,
    LastDate,
  },
  valuatedType,
}) => {
  const contentClasses = classNames('InfoWindow__Body__Content')
  const titleClasses = classNames('InfoWindow__Body__Content__Title')
  const capitalizedClasses = classNames('InfoWindow--capitalized')
  const rowClasses = classNames('InfoWindow__Row')
  return (
    <Grid fluid className={contentClasses}>
      <Row between="xs" center="xs" className={titleClasses}>
        <Col xs={12} md={11} className={capitalizedClasses}>
          <h2>
            {Category} - {valuatedType}
          </h2>
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col xs={12} className={capitalizedClasses}>
          <b>Endereço: </b> {Address && `${Address} - `}
          {Neighborhood && `${Neighborhood}, `}
          {City && `${City}`}
          {Cep && `, ${Cep}`}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col xs={12} md={6}>
          <b>Dormitórios: </b> {Bedrooms}
        </Col>
        <Col xs={12} md={5}>
          <b>Área Total (m²): </b>
          {TotalArea}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Garagens: </b>
          {Garages}
        </Col>
        <Col md={5} xs={12}>
          <b>Área Útil (m²): </b>
          {UsefulArea}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Lance (1ª praça): </b>
          {FirstAuctionValue ? (
            <Fragment>
              R${' '}
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                value={FirstAuctionValue}
                displayType="text"
              />
              {(FirstAuctionDate &&
                ' - ' +
                  new Date(FirstAuctionDate)
                    .toLocaleDateString()
                    .split(' ')
                    .join('/')) ||
                ''}
            </Fragment>
          ) : (
            'Não Disponível'
          )}
        </Col>
        <Col md={5} xs={12}>
          <b>Lance (2ª praça): </b>
          {SecondAuctionValue ? (
            <Fragment>
              R${' '}
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                value={SecondAuctionValue}
                displayType="text"
              />
              {(SecondAuctionDate &&
                ' - ' +
                  new Date(SecondAuctionDate)
                    .toLocaleDateString()
                    .split(' ')
                    .join('/')) ||
                ''}
            </Fragment>
          ) : (
            'Não Disponível'
          )}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Valor de Venda: </b>
          {ClosureValue ? (
            <Fragment>
              R${' '}
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                value={ClosureValue}
                displayType="text"
              />
              {(ClosureDate &&
                ' - ' +
                  new Date(ClosureDate)
                    .toLocaleDateString()
                    .split(' ')
                    .join('/')) ||
                ''}
            </Fragment>
          ) : (
            'Não Disponível'
          )}
        </Col>
        <Col md={5} xs={12}>
          <b>Deságio: </b>
          {NegativeGoodwill || 'Não Disponível'}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Ultimo Valor: </b>
          {Price ? (
            <Fragment>
              R${' '}
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                value={Price}
                displayType="text"
              />
              {(LastDate &&
                ' - ' +
                  new Date(LastDate)
                    .toLocaleDateString()
                    .split(' ')
                    .join('/')) ||
                ''}
            </Fragment>
          ) : (
            'Não Disponível'
          )}
        </Col>
        <Col md={5} xs={12}>
          <b>Status: </b>
          {IsOccupied === undefined
            ? 'Não Disponível'
            : (IsOccupied && 'Ocupado') || 'Não ocupado'}
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Valor Avaliado: </b>
          {RatedValue ? (
            <Fragment>
              R${' '}
              <CurrencyFormat
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                value={RatedValue}
                displayType="text"
              />
            </Fragment>
          ) : (
            'Não Disponível'
          )}
        </Col>
        <Col md={5} xs={12}>
          <div style={{ marginBottom: '3px' }}>
            <b>Arquivos: </b>
          </div>
          <div className="InfoWindow__Col InfoWindow__Col--overflow">
            {(DocumentsList &&
              DocumentsList.map(item => (
                <div
                  onClick={() =>
                    handleDocDownloadClick(
                      item,
                      item.split('/')[1].split('.')[0],
                    )
                  }
                  key={item}
                  title={item.split('/')[1].split('.')[0]}
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <span>{item.split('/')[1]} </span>
                  <i className="material-icons">picture_as_pdf</i>{' '}
                </div>
              ))) ||
              'Não Disponível'}
          </div>
        </Col>
      </Row>
      <Row between="xs" start="xs" className={rowClasses}>
        <Col md={6} xs={12}>
          <b>Url: </b>
          <Button
            type="submit"
            btnSize="xs"
            btnStyle="link"
            className="InfoWindow__Body__Content__Btn"
            onClick={() => window.open(Link, '_tab')}
          >
            <i className="material-icons">visibility</i>
            Ver Leilão
          </Button>
        </Col>
      </Row>
    </Grid>
  )
}

const InfoWindow = props => {
  const {
    content,
    toggleInfoWindow,
    mobile,
    openReportModal,
    businessType,
    valuatedType,
  } = props
  const realty = { content, businessType, valuatedType }
  const classes = classNames({
    InfoWindow: !mobile,
    'InfoWindow--mobile': mobile,
    'InfoWindow--valuated': realty && realty.content.IsAudit,
  })
  return (
    <div className={classes}>
      <div className="InfoWindow__Body">
        <div className="InfoWindow__Header">
          <i className="material-icons" onClick={toggleInfoWindow}>
            close
          </i>
        </div>
        {realty && realty.content.Id ? (
          realty.content.IsAudit ? (
            renderValuated(realty, openReportModal)
          ) : (
            renderRealty(realty, openReportModal)
          )
        ) : (
          <div className="InfoWindow__Loader">
            <Loader sizeUnit="px" size={50} color={COLORS.gray28} visible />
            Carregando
          </div>
        )}
      </div>
    </div>
  )
}

export default InfoWindow
